import { Recipe } from '../../api/Recipe';

export const buildPublicRecipeUrl = (recipeId: string): string =>
  `${window.location.origin}/recipe/${recipeId}`;

export const buildShareRecipePayload = (recipe: Recipe, publicRecipeUrl: string) => ({
  title: `Recette : ${recipe.title}`,
  text: `Découvrez cette recette de ${recipe.title} sur La Marmite Familiale !`,
  url: publicRecipeUrl,
});

export const getFavoriteToggleErrorMessage = (error: unknown) =>
  typeof error === 'object' &&
  error !== null &&
  'message' in error &&
  typeof (error as { message?: unknown }).message === 'string'
    ? (error as { message: string }).message
    : 'Impossible de mettre a jour les favoris.';
